<template>
    <div>
        <div class="error-div">
            {{msg}}
        </div>
    </div>

</template>

<script>
    export default {
        name: "ErrorPage",
        data(){
          return {
              msg: ''
          }
        },
        created: function () {
            this.msg = this.$route.query.errmsg;
        },
    }
</script>

<style scoped>
    .error-div{
        width: 100%;
        text-align: center;
        margin-top: 100px;
        font-size: 30px;
        color: #666666;
    }
</style>